import React from 'react';

export const useFocus = <T>(
  onFocus: React.FocusEventHandler<T> | undefined,
  onBlur: React.FocusEventHandler<T> | undefined
): {
  focused: boolean;
  handleFocus: React.FocusEventHandler<T>;
  handleBlur: React.FocusEventHandler<T>;
} => {
  const [focused, setFocused] = React.useState(false);
  const handleFocus = React.useCallback<React.FocusEventHandler<T>>(
    (e) => {
      setFocused(true);
      if (onFocus) {
        onFocus(e);
      }
    },
    [onFocus]
  );
  const handleBlur = React.useCallback<React.FocusEventHandler<T>>(
    (e) => {
      setFocused(false);
      if (onBlur) {
        onBlur(e);
      }
    },
    [onBlur]
  );

  return { focused, handleFocus, handleBlur };
};
